import { render, staticRenderFns } from "./ClientMailsModalComponent.vue?vue&type=template&id=7705c545&scoped=true"
import script from "./ClientMailsModalComponent.vue?vue&type=script&lang=js"
export * from "./ClientMailsModalComponent.vue?vue&type=script&lang=js"
import style0 from "./ClientMailsModalComponent.vue?vue&type=style&index=0&id=7705c545&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7705c545",
  null
  
)

export default component.exports